import {
    GET_SELECTED_DEVICE_RAW_DATA, LOADING_SELECTED_DEVICE_RAW_DATA, ERROR_SELECTED_DEVICE_RAW_DATA, CLEAR_SELECTED_DEVICE_RAW_DATA
} from "./constants";

const initialState = {
    id: null,
    name: null,
    loading: true,
    error: '',
    rawData: [],
    count: 0,
    limit: 0,
    offset: 0,
    lineGraph: [],
    isError:false
}

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case LOADING_SELECTED_DEVICE_RAW_DATA:
            return {
                ...state,
                loading: true,
                error: '',
                isError: false
            }
        case GET_SELECTED_DEVICE_RAW_DATA:
            return {
                ...state,
                id: payload.id,
                name: payload.name,
                rawData: payload.rawData,
                count: payload.count,
                limit: payload.limit,
                offset: payload.offset,
                loading: false,
                isError:false,
                error: ''
            }
        case ERROR_SELECTED_DEVICE_RAW_DATA:
            return {
                ...state,
                isError:true,
                error: payload,
                loading: false,
                rawData: [],
                count: 0
            }
        case CLEAR_SELECTED_DEVICE_RAW_DATA:
            return initialState
        default:
            return state;
    }
}